var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[(_vm.label)?_c('label',{attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.type === 'static')?_c('div',{staticClass:"static"},[_vm._v(_vm._s(_vm.modelValue))]):_c('input',{attrs:{"id":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.modelValue},on:{"change":_vm.onChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }